export default __webpack_public_path__ + "static/media/logo-scv.9aed67e1.svg";